import React from 'react';
import { map, flatten } from 'lodash';
import classnames from 'classnames';
import renderRawHtml from '../../../common/render_raw_html';
import { Accordion } from '../common/accordion';

const menuList = [
  {
    title: 'Shop',
    noPaddingLeft: true,
    borderRight: true,
    items: [
      { title: 'Devices' },
      { title: 'Accessories' },
      { title: 'Plans' },
      { title: 'Prepaid' },
      { title: 'Home Internet & TV' },
      { title: 'Deals' },
      { title: 'Mobile + Home discount' },
      { title: 'Bring your own device' },
      { title: 'TracFone' }
    ]
  },
  {
    title: 'Top Device Brands',
    borderRight: true,
    items: [
      { title: 'Samsung' },
      { title: 'Apple' },
      { title: 'Google' },
      { title: 'Amazon' }
    ]
  },
  {
    title: 'Support',
    borderRight: true,
    items: [
      { title: 'Support overview' },
      { title: 'Return policy' },
      { title: 'Contact us' },
      { title: 'Community Forums' },
      { title: 'Business support' },
      { title: 'Sign in' },
      { title: 'Download My Verizon App' },
      { title: 'Lifeline' },
      { title: 'Accessibility' },
      { title: 'Network support' },
      { title: 'Speed Test' }
    ]
  },
  {
    title: 'About Verizon',
    items: [
      { title: 'About us' },
      { title: 'Careers' },
      { title: 'News' },
      { title: 'Responsibility' },
      { title: 'Verizon Innovative Learning' },
      { title: 'Articles' },
      { title: 'Brochures' },
      { title: '5G overview' },
      { title: 'Innovation Labs' }
    ]
  },
  {
    title: 'Most Popular',
    noPaddingLeft: true,
    borderRight: true,
    items: [
      { title: 'Apple iPhone 16 Pro Max' },
      { title: 'Apple iPhone 16 Plus' },
      { title: 'Samsung Galaxy S25 Ultra' },
      { title: 'Apple AirPods Max' },
      { title: 'Disney+, Hulu, & ESPN+ (With Ads)' },
      { title: 'Apple Watch Series 10' },
      { title: 'Fios' },
      { title: 'Verizon Visa® Card' }
    ]
  },
  {
    title: 'Top Accessory Brands',
    borderRight: true,
    items: [
      { title: 'Otterbox' },
      { title: 'ZAGG' },
      { title: 'Beats' },
      { title: 'Mophie' },
      { title: 'JBL' },
      { title: 'Fitbit' },
      { title: 'Elizabeth James' }
    ]
  },
  {
    title: 'Important Consumer Information',
    borderRight: true,
    items: [
      { title: 'Terms & Conditions' },
      { title: 'Device Payment Terms & Conditions' },
      { title: 'Report a security vulnerability' },
      { title: 'Mobile customer agreement' },
      { title: 'Announcements' },
      { title: 'Radio frequency emissions' },
      { title: 'Taxes & surcharges' },
      { title: 'Legal notices' },
      { title: 'NMLS Consumer Access (NMLS ID #1165814)' }

    ]
  },
  {
    accordionAlwaysShow: true,
    subitems: [
      {
        title: 'Follow Verizon',
        svgItems: [
          { name: 'social-facebook', className: 'icon-facebook' },
          { name: 'social-xwitter', className: 'icon-xwitter' },
          { name: 'social-youtube', className: 'icon-youtube' },
          { name: 'social-instagram', className: 'icon-instagram' },
          { name: 'social-tiktok', className: 'icon-tiktok' }
        ]
      },
      {
        title: 'Verizon Support',
        svgItems: [ { name: 'social-xwitter', className: 'icon-xwitter' } ]
      }
    ]
  }
];

const accordionList = flatten(
  map(
    menuList,
    (el, elIndex) => {
      if (el.items) {
        const result = { title: el.title };
        if (el.accordionAlwaysShow) {
          result.alwaysShow = true;
        }
        result.description = (
          <ul>
            {
              map(el.items, (item, itemIndex) => (
                <li key={ `el${elIndex}${itemIndex}` }>{ item.title }</li>
              ))
            }
          </ul>
        );
        return result;
      } else if (el.subitems) {
        return map(el.subitems, (subItem, subItemIndex) => {
          const result = { title: subItem.title };
          if (el.accordionAlwaysShow) {
            result.alwaysShow = true;
          }
          result.description = (
            <div className="svg-list">
              {
                map(subItem.svgItems, (svgItem, svgItemIndex) => (
                  <div className="svg-item" key={ `el${elIndex}${subItemIndex}${svgItemIndex}` }>
                    <svg className={ classnames("svg-icon", svgItem.className) }>
                      <use xlinkHref={ `#svg_${svgItem.name}` } />
                    </svg>
                  </div>
                ))
              }
            </div>
          );
          return result;
        });
      }
    }
  )
);

const FooterMenu = () => {
  return (
    <section className="footer_section footer-menu">
      <div className="container">
        <div className="footer-table">
          {
            map(menuList, (el, elIndex) => (
              <div
                className={
                  classnames(
                    "footer-table-box",
                    {
                      'border-right': el.borderRight,
                      'no-padding-left': el.noPaddingLeft,
                      'no-padding-right': el.noPaddingRight
                    }
                  )
                } key={ `el${elIndex}` }
              >
                { !!el.title && <h3 { ...renderRawHtml(el.title) } /> }
                {
                  !!el.items &&
                  <ul>
                    {
                      map(el.items, (item, itemIndex) => (
                        <li key={ `item${elIndex}${itemIndex}` }>
                          <span { ...renderRawHtml(item.title) } />
                        </li>
                      ))
                    }
                  </ul>
                }
                {
                  !!el.subitems &&
                  <div className="footer-table-box-subitems">
                    {
                      map(el.subitems, (item, itemIndex) => (
                        <div className="footer-table-sub-box" key={ `el${elIndex}${itemIndex}` }>
                          <h3 { ...renderRawHtml(item.title) } />
                          <div className="svg-list">
                            {
                              map(item.svgItems, (svgItem, svgItemIndex) => (
                                <div className="svg-item" key={ `el${elIndex}${itemIndex}${svgItemIndex}` }>
                                  <svg className={ classnames("svg-icon", svgItem.className) }>
                                    <use xlinkHref={ `#svg_${svgItem.name}` } />
                                  </svg>
                                </div>
                              ))
                            }
                          </div>
                        </div>
                      ))
                    }
                  </div>
                }
              </div>
            ))
          }
        </div>
        <div className="footer-accordion">
          <Accordion list={ accordionList } className="footer-menu-items" />
        </div>
      </div>
    </section>
  );
};

export default FooterMenu;
